import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import _ from 'underscore';
import { Link } from 'react-router-dom';
import Moment from 'moment';

import {
    getSystemAdminHrClaimsListData
} from '../../actions';

class SysadminHrclaimsListPage extends Component {
    componentDidMount() {
        if (this.props.user) {
            const { accessToken } = this.props.user;
            if (accessToken) {
                this.props.getSystemAdminHrClaimsListData(accessToken);
            }
        }
    }
    render() {
        return (
            <Table celled selectable>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>View</Table.HeaderCell>
                        <Table.HeaderCell>Client</Table.HeaderCell>
                        <Table.HeaderCell>Type</Table.HeaderCell>
                        <Table.HeaderCell>Provider</Table.HeaderCell>
                        <Table.HeaderCell>Amount</Table.HeaderCell>
                        <Table.HeaderCell>Submitted By</Table.HeaderCell>
                        <Table.HeaderCell>Created</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {
                        _.map(this.props.hrclaims, (claim, index) => {
                            const {
                                _id,
                                companyName,
                                typeOfClaim,
                                providerName,
                                userName,
                                currency,
                                amount,
                                created
                            } = claim;
                            return (
                                <Table.Row key={_id}>
                                    <Table.Cell>
                                        <Link to={`/systemadmin/hrclaims/view/${_id}`}>
                                            View
                                        </Link>
                                    </Table.Cell>
                                    <Table.Cell>{companyName}</Table.Cell>
                                    <Table.Cell>{typeOfClaim}</Table.Cell>
                                    <Table.Cell>{providerName}</Table.Cell>
                                    <Table.Cell>{currency} {amount}</Table.Cell>
                                    <Table.Cell>{userName}</Table.Cell>
                                    <Table.Cell>{Moment(created).format('DD/MM/YYYY hh:mm')}</Table.Cell>
                                </Table.Row>
                            );
                        })
                    }
                </Table.Body>
            </Table>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        clients: state.systemAdmin.clients,
        hrclaims: state.systemAdmin.hrclaims,
    };
}

export default connect(mapStateToProps, {
    getSystemAdminHrClaimsListData,
})(SysadminHrclaimsListPage);